import { Component, Inject, Input, PLATFORM_ID } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { fieldTypes } from '@constants/constant';
import { isPlatformBrowser } from '@angular/common';
import type { Field } from '@modules/dynamic-form-builder/model/formBuilderInterface';

@Component({
  selector: 'app-input',
  templateUrl: './input.component.html',
  styleUrls: ['./input.component.scss']
})
export class FormInputComponent{
  @Input() field: Field;
  @Input() form: FormGroup;
  inputHidden = false;
  inputType = 'text';
  constructor(
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

   ngOnInit() {
    this.updateInputType();
   }

  isPasswordField(): boolean {
    return this.field?.type === fieldTypes.PASSWORD;
  }

  disableScroll(event: WheelEvent) {
    if (fieldTypes.NUMBER === this.field.type) event?.preventDefault();
  }
  
  preventPaste(event: ClipboardEvent): void {
    if (this.field?.notAllowPaste) {
      event.preventDefault();
      const input = event.target as HTMLInputElement;
      if (isPlatformBrowser(this.platformId)) {
        requestAnimationFrame(() => {
          if (input) {
            input.value = '';
          }
          const control = this.form.get(this.field.name);
          if (control) {
            control.setValue('', { emitEvent: false });
          }
        });
      }
    }
  }
  
  trimInputValue() {
    const control = this.form.get(this.field.name);
    if (control) {
      const value = control.value;
      if (this.field.type === fieldTypes.TEXT && value) {
        control.setValue(value.trim());
      }
    }
    if (this.field.hideOnBlur) {
      this.inputHidden = true;
      this.updateInputType();
    }
  }
  handleFocus() {
    if (this.field.hideOnBlur) {
      this.inputHidden = false;
      this.updateInputType();
    }
  }

  updateInputType() {
    if (this.field.hideOnBlur && this.inputHidden) {
      this.inputType = fieldTypes.PASSWORD;
    } else {
      this.inputType = this.field.type;
    }
  }

  getInputPaddingRight(): string {
    const paddingRight = this.field?.suffixButton ? 62 : 0;
    return paddingRight ? `${paddingRight}px` : '';
  }

  isSuffixButtonDisabled(): boolean {
    const sb = this.field?.suffixButton;
    return !!sb?.disabled?.();
  }

}
